import * as types from './machineStandStillActionTypes';

export const setMachineStandStillInfo = (machineStandStillInfo) => ({type: types.SET_MACHINESTANDSTILLINFO, machineStandStillInfo: machineStandStillInfo});